import { render } from "./server-settings.vue?vue&type=template&id=44b40959&scoped=true&ts=true"
import script from "./server-settings.vue?vue&type=script&lang=ts"
export * from "./server-settings.vue?vue&type=script&lang=ts"

import "./server-settings.vue?vue&type=style&index=0&id=44b40959&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b40959"]])

export default __exports__